import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {
  getAddressList,
  getPaginationUrls,
  getTotalCount,
} from "../../../redux/Selectors/address.selectors";
import {generateNumericAwareQueryUrl} from "../../../helpers/generateNumericAwareQueryUrl";
import {addressActions} from "./addressTable.constants";
import useListAddressURL from "./useListAddressUrl";

export const useFetchAddress = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(addressActions.load());
  };

  const refetch = () => {
    dispatch(addressActions.load(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useAddressTableData = () => {
  const dispatch = useDispatch();
  const {addressURL} = useListAddressURL();
  const {refetch, freshFetch} = useFetchAddress();
  const {setPageUrl} = usePageURLContext();
  const addressList = useSelector(getAddressList);
  const addressTotalCount = useSelector(getTotalCount);
  const addressUrls = useSelector(getPaginationUrls);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAfterDelete = () => {
    if (addressList.length === 1) {
      // If the last address on the current page is deleted, reset to the first page
      setCurrentPage(1);
      setPageUrl("");
      freshFetch();
    } else {
      refetch();
    }
  };

  const handlePageChange = (page) => {
    const url = currentPage < page ? addressUrls?.nextUrl : addressUrls?.prevUrl;
    dispatch(addressActions.load(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      const searchUrl = generateNumericAwareQueryUrl(addressURL, tokens);
      dispatch(addressActions.load(searchUrl));
      setPageUrl(searchUrl);
      setCurrentPage(1);
    } else {
      dispatch(addressActions.load());
      setPageUrl("");
      setCurrentPage(1);
    }
  };

  return {
    addressList,
    addressTotalCount,
    fetchAfterDelete,
    handleSearch,
    paginationConfig,
  };
};
